import React from 'react'

import {
    TreeSelect
} from 'antd'

class CategoryTreeSelect extends React.Component {
    render(){

        let categories = this.props.categories;
        let treeData = [];

        categories.map(( category, catIndex ) => {

          let newChildren = [];

          category.children.map(( subCat, subIndex ) => {

            let binaryCatIndex = this.formatNumberLength(catIndex, 3);
            let binarySubIndex = this.formatNumberLength(subIndex, 3);

            newChildren.push({
              title: subCat.title,
              value: `${binaryCatIndex}${binarySubIndex}${subCat.title}`,
              key: subCat.titleUrl
            });

            return subCat;
          })

          treeData.push({
            title: category.title,
            value: `parent-${category._id}`,
            key: category._id,
            children: newChildren
          });

          return category;
        })

        return(
            <TreeSelect 
                showSearch
                value={this.props.value}
                style={{ width: 300 }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="Select Sub Category"
                allowClear
                treeData={treeData}
                onChange={this.props.onTreeSelectChange}
                treeDefaultExpandAll
                />
        )
    }

    formatNumberLength = ( num, length ) => {
        let r = "" + num;
        while (r.length < length) {
            r = "0" + r;
        }
        return r;
      }
}

export default CategoryTreeSelect


// WEBPACK FOOTER //
// ./src/components/leaf-page/modals/tree-select.js